import React from "react";
import { Typography, Button, Box, Card} from "@mui/material";
import checkedSuccsessIcon from '../../../../icons/untitled-ui/icons/checked.png'
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ConfirmTab = ({ user, handleTabsChange }) => {

  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '20px',
            textAlign: 'center',
            mx: 'auto',
            width: '100%'
        }}>
            <Card sx={{maxWidth: '500px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px', textAlign: 'center', p: 3}} variant="outlined">
                <img src={checkedSuccsessIcon} alt="Success" style={{
                    width: '100px',
                    height: '100px'
                }}/>
                <Typography variant="h3">{t("views.subscriptions.success")}</Typography>
                <Typography variant="h5">{t("views.subscriptions.orderProcessed")}</Typography>
                <Typography variant="body1">{t("views.subscriptions.emailAfterTransactionInfo")}</Typography>
                <Button variant="contained" onClick={() => {
                    handleTabsChange('billing-history')
                }}>{t("views.subscriptions.returnToInvoices")}</Button>
                <Button variant="contained" onClick={() => {
                    handleTabsChange('my-subscriptions')
                }}>{t("views.subscriptions.returnToSubscriptions")}</Button>
            </Card>
        </Box>
    </>
  );
};

export default ConfirmTab;
